/* eslint-disable */

export default {
	common: {
		'1': '一月',
		'2': '二月',
		'3': '三月',
		'4': '四月',
		'5': '五月',
		'6': '六月',
		'7': '七月',
		'8': '八月',
		'9': '九月',
		'10': '十月',
		'11': '十一月',
		'12': '十二月',
		adults: '大人',
		children: '小孩',
		bookNow: '立即訂房',
		prev: '上一則',
		backToHome: '回列表頁',
		next: '下一則',
		detail: '詳細資訊',
		selectDate: '選擇日期',
		selectHotel: '選擇分館',
		onlineTravelFair: '線上旅展',
		bookNowBtn: '立即預訂',
	},
	pageTitle: {
		brandName: 'Just Sleep 捷絲旅',
		main: '品牌首頁',
		news: '最新優惠',
		privacy: '隱私權聲明與 Cookie 政策',
		accommodation: '房型介紹',
		facility: '設施服務',
		restaurant: '餐廳會議',
		location: '交通景點',
		activity: '館內活動',
	},
	header: {
		main: '品牌首頁',
		news: '最新優惠',
		index: '分館首頁',
		accommodation: '房型介紹',
		facility: '設施服務',
		restaurant: '餐廳會議',
		location: '交通景點',
		activity: '館內活動',
		bookNow: '立即訂房',
		taiwan: '台灣',
		japan: '日本',
		onlineTravelFair: '線上旅展',
		bookNowBtn: '立即預訂',
	},
	footer: {
		registrationNumber: '旅館業登記證編號',
		privacy: '隱私權聲明與 Cookie 政策',
	},
	cookieBar: {
		attention:
			'<p>我們重視且尊重您的隱私。</p>\n<p>晶華國際酒店集團的全球官方網站是使用獨立的第三方Cookie來提升網站的表現、分析數據以及達到更精準的投放廣告。若您瀏覽此網站，即代表您同意我們使用第三方Cookie。若欲了解更多相關資訊，建議您可前往我們的{{privacyLink}}網頁進行查看。</p>',
		privacy: '隱私權聲明與 Cookie 政策',
		accept: '同意，並瀏覽網站',
	},
	homePage: {
		title: '風格優旅 心細如縷',
		about: '關於',
		aboutJustsleep: '關於捷絲旅',
		toHotelSite: '前往官網',
		more: '暸解更多',
		justNews: '最新消息',
		justComfortTitle: 'Just 好眠',
		justComfortBackTitle: 'Just 好眠',
		justComfortContent:
			'飯店內提供不同的枕頭選擇，使毎一位下榻捷絲旅的旅人，皆可獲得舒適的睡眠品質。',
		justGoTitle: 'Just 好遊',
		justGoBackTitle: 'Just 好遊',
		justGoContent: '飯店內提供旅遊諮詢服務，依據每一位旅人的需求推薦景點、購物好店及交通資訊。',
		justEquipTitle: 'Just 備品',
		justEquipBackTitle: 'Just 備品',
		justEquipContent:
			'提供自拍神器、手機充電器、行動電源、檯燈等特殊備品（限台北西門館、及臺大尊賢館）。',
		justBuyTitle: 'Just 好買',
		justBuyBackTitle: 'Just 好買',
		justBuyContent: '提供代購台灣特色伴手禮之服務，為旅人省下時間、輕鬆旅遊。',
		justPackTitle: 'Just 打包',
		justPackBackTitle: 'Just 打包',
		justPackContent: '提供行李秤重及各尺寸紙箱選購之服務，由專人幫您免費打包、輕鬆返程。',
		justRelax: '便捷設施',
		justSight: '景點介紹',
		justGo: 'Just 好遊',
		justExplore: '捷絲旅·探索',
		justService: '貼心服務',
	},
	accommodationPage: {
		rooms: '房型介紹',
		roomFacilityTitle: '客房設施 • 備品',
		lookupRoomType: '查看客房類型',
		have: '共有',
		roomType: '房型',
		am: '上午',
		pm: '下午',
		checkInTime: '入住時間',
		checkOutTime: '退房時間',
		detail: '詳細資訊',
		bookNow: '立即訂房',
	},
	locationPage: {
		location: '交通景點',
		trainInfo: '臺鐵/高鐵資訊',
		busInfo: '客運資訊',
		driveInfo: '開車資訊',
		parkInfo: '停車資訊',
		hotelInfo: '飯店接駁',
		airplaneInfo: '機場資訊',
	},
	newsHomePage: {
		all: '全部',
		news: '最新優惠',
		selectType: '選擇類型',
		more: '暸解更多',
	},
	newsPage: {
		projectTime: '專案期間',
		projectDetail: '專案內容',
		note: '備註',
	},
	restaurantPage: {
		restaurantsAndMeetings: '餐廳會議',
		restaurant: '餐廳',
		meeting: '會議',
	},
	activityPage: {
		activity: '館內活動',
		attractionsNearby: '推薦景點',
		more: '暸解更多',
		lookupSchedule: '查看行程',
		join: '立刻報名',
	},
	facilityPage: {
		facility: '設施服務',
		lookup: '查看簡介',
	},
	justFunSection: {
		justFun: '西門十趣',
	},
	hotelMain: {
		name: '品牌首頁',
		title: '',
		longName: '品牌首頁',
		bannerText: '捷絲旅',
		contactUs: '客服信箱',
		address: '台北市羅斯福路四段83號',
		intro:
			'「Just Sleep 捷絲旅」為晶華國際酒店集團旗下之設計型旅館品牌，秉持「風格優旅，心細如縷」的品牌精神，使旅人可以親民、實惠的價格，享受媲美五星飯店的優質服務。',
	},
	hotelXimen: {
		name: '台北西門館',
		title: '',
		contactUs: '客服信箱',
		address: '台北市中正區中華路一段41號5樓（請由漢口街一段144號出入）',
		intro:
			'「捷絲旅台北西門館」鄰近繁華、熱鬧的西門町商圈，旅人可輕鬆暢遊台北市最具歷史故事的景點，體驗台味新潮文化之餘，亦可品嘗道地美食。\n',
	},
	hotelNTU: {
		name: '臺大尊賢館',
		title: '',
		contactUs: '客服信箱',
		address: '台北市大安區羅斯福路四段83號',
		intro:
			'「捷絲旅臺大尊賢館」位於國立台灣大學旁，提供至校園教學、實習、研究、學術交流、會議及參訪人員舒適旅宿的選擇，館內將自在的學院風格融入設計中，營造與校園共榮的氛圍。',
	},
	hotelZhongshan: {
		name: '台北中山館',
		title: '',
		contactUs: '客服信箱',
		address: '台北市中山區中山北路一段135巷39號',
		intro:
			'「捷絲旅台北中山館」座落於揉合歷史底蘊與現代活力的中山區，鄰近捷運中山站，交通便利性極佳。旅人可輕鬆漫步探索繁華的條通及中山商圈，感受舊城文化與新潮時尚的交織，是海內外旅人深度體驗台北輕旅行的理想下榻首選。',
	},
	hotelKaohsiung: {
		name: '高雄中正館',
		title: '',
		contactUs: '客服信箱',
		address: '高雄市苓雅區中正一路134號',
		intro:
			'「捷絲旅高雄中正館」以音樂風格為設計主軸，內部空間設計兼具時尚音樂風格與實用功能。本館臨近高雄捷運苓雅運動園區站(舊名:技擊館站)、衛武營國家藝術文化中心及武廟夜市，將提供旅人不同凡響的旅宿體驗。\n',
	},
	hotelKaohsiungStation: {
		name: '高雄站前館',
		title: '',
		contactUs: '客服信箱',
		address: '高雄市新興區中山一路280號',
		intro:
			'「捷絲旅高雄站前館」以視覺藝術為主軸，將美學融入飯店設計中，兼具精品魅力及文創的時尚氣息。本館臨近高雄火車站、捷運美麗島站及六合夜市，能便利前往不同的景點，為旅客休憩的首選。',
	},
	hotelHualien: {
		name: '花蓮中正館',
		title: '',
		contactUs: '客服信箱',
		address: '花蓮市中正路396號',
		intro:
			'「捷絲旅花蓮中正館」以文學為主軸，設有圖書館、兒童遊戲室，使旅人休憩其中並獲得放鬆，坐落於市中心，臨近知名美食店家、著名的東大門夜市，亦可輕鬆品嚐在地特色小吃。\n',
	},
	hotelJiaoxi: {
		name: '宜蘭礁溪館',
		title: '',
		contactUs: '客服信箱',
		address: '宜蘭縣礁溪鄉德陽路24巷8號',
		intro:
			'「捷絲旅宜蘭礁溪館」鄰近熱鬧的礁溪商圈，全館提供碳酸氫鈉溫泉，是礁溪地區設計旅店的全新指標，旅人步行即可至著名觀光景點如五峰旗風景區、湯圍溝溫泉公園等。\n',
	},
	hotelSanchong: {
		name: '台北三重館',
		title: '',
		contactUs: '客服信箱',
		address: '新北市三重區三和路四段107-1號（捷運三和國中站2號出口往後走1分鐘）',
		intro:
			'「捷絲旅台北三重館」擁有絕佳的地理位置，捷運三和國中站就在門口，交通四通八達；商務住宿或是旅遊休憩均十分方便。全新的輕工業風建築，透過手工烘培的咖啡與台灣原片茶，傳達給每一位旅人在舒適的客房休息之餘，還有溫潤貼心的服務與感受。',
	},
	hotelHushan: {
		name: '台南虎山館',
		title: '',
		contactUs: '客服信箱',
		address: '台南市仁德區文華路二段300號',
		intro:
			'「捷絲旅台南虎山館」緊鄰十鼓仁糖文創園區、奇美博物館，讓旅人輕鬆探索文藝景點享盡地利之便。鄰近高鐵站、機場、高速公路等交通要點，是商務活動及親子度假的飯店首選。',
	},
	hotelOsakaShinsaibashi: {
		name: '大阪心齋橋館',
		title: '',
		contactUs: '客服信箱',
		address: '542-0081大阪市中央區南船場二丁目9-15',
		intro:
			'「捷絲旅大阪心齋橋館」是捷絲旅品牌進軍日本的首家據點，飯店位置緊鄰熱鬧繁華的心齋橋商圈，商圈內美食店舖林立，房客步行即可沉浸式的體驗在地潮流文化與熱情好客的風土民情。\n飯店對外交通四通八達，心齋橋站、本町站、堺筋本町及長堀橋站等四大地鐵車站近在咫尺，出行時便利性十足，絕對是旅人規劃大阪自由行時的住宿首選。',
		tel: 'Tel : +81-06-6251-3666',
		fax: 'Fax : +81-06-6251-3889',
	},
};

/* eslint-enable */



// WEBPACK FOOTER //
// ./src/util/resources/zh-TW.js